import React, { useEffect, useState } from 'react';
import { differenceInCalendarDays } from 'date-fns';
import { getTopOffset } from './weekGrid';
import s from './NowIndicator.module.css';

// The red line across today's column.
//
// Re-renders every minute so it tracks the actual time rather than freezing at
// whatever time the calendar was mounted.
//
// `weekStart` is the first column's day and `dayCount` how many columns there
// are: seven on the week, one on the Day view, which is the same grid one
// column wide (#572).
export default function NowIndicator({ weekStart, dayCount = 7 }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 60_000);
    return () => clearInterval(id);
  }, []);

  const now = new Date();
  const dayIndex = differenceInCalendarDays(now, weekStart);
  if (dayIndex < 0 || dayIndex > dayCount - 1) return null;
  // The grid is the whole day (#749), so the line is drawn at any time, at its
  // minute from midnight.

  return (
    <div
      className={s.column}
      style={{
        left: `calc((100% / ${dayCount}) * ${dayIndex})`,
        width: `calc(100% / ${dayCount})`,
        top: getTopOffset(now),
      }}
    >
      <div className={s.line}><div className={s.dot} /></div>
    </div>
  );
}
